import React, { useState, useMemo, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'

import { useDispatch } from 'react-redux'
import { removeHarness } from 'actions/feature/harnesses'

import strings from 'utils/strings'
import { formatIdAttribute } from 'utils/harnesses'

import { useSelector } from 'hooks/redux'
import { getFeatureHarnessIds } from 'selectors/feature/harnesses'
import { getIsPreCreateFeature } from 'selectors/feature/features'
import { getIsEditing } from 'selectors/navigator'

import { Header } from 'components/patterns'

import HarnessTable from './HarnessTable'
import withStyle, { StyledDynamicTabs } from './Harnesses.style'

const Harnesses = ({ className }) => {
  const dispatch = useDispatch()
  const isPreCreate = useSelector(getIsPreCreateFeature)
  const isEditing = useSelector(getIsEditing)
  const harnesses = useSelector(getFeatureHarnessIds)
  const [selectedHarness, setSelectedHarness] = useState(
    formatIdAttribute(harnesses[0])
  )

  useEffect(() => {
    if (isEmpty(harnesses)) {
      setSelectedHarness(null)
    }
  }, [harnesses])

  const harnessesMapped = useMemo(() => {
    return harnesses.map(({ partNumber, revision }) => ({
      key: formatIdAttribute({ partNumber, revision }),
      title: partNumber,
      subtitle: revision !== '-' ? strings.revision_subtitle(revision) : null,
    }))
  }, [harnesses])

  const handleTempAdd = () => {
    setSelectedHarness(null)
  }

  const handleRemoveHarness = useCallback(
    (harnessId) => dispatch(removeHarness(harnessId)),
    [dispatch]
  )

  return (
    <div className={className}>
      <Header type="h3">{strings.harnesses}</Header>
      <StyledDynamicTabs
        items={harnessesMapped}
        selectedItem={selectedHarness}
        onClick={setSelectedHarness}
        onAdd={handleTempAdd}
        onRemove={handleRemoveHarness}
        editable={isEditing || isPreCreate}
      />
      <HarnessTable id={selectedHarness} onAdd={setSelectedHarness} />
    </div>
  )
}

Harnesses.propTypes = {
  className: PropTypes.string,
}

export default withStyle(Harnesses)
